const GridMedium = (props) => {
    const { fill } = props
    return (
        <svg
            cursor="pointer"
            fill={fill}
            viewBox="0 0 64 64"
            data-testid="Grid__Medium"
            {...props}
        >
            <title>Medium Grid Density</title>
            <g transform="matrix(2.66667,0,0,2.66667,0,0)">
                <g transform="matrix(1.17218,0,0,1.15079,-2.65792,-1.30906)">
                    <path d="M16,5L16,11L21,11L21,5M10,11L15,11L15,5L10,5M16,18L21,18L21,12L16,12M10,18L15,18L15,12L10,12M4,18L9,18L9,12L4,12M4,11L9,11L9,5L4,5L4,11Z" />
                </g>
            </g>
        </svg>
    )
}

export default GridMedium
